export default __webpack_public_path__ + "static/media/TermFinsihedIcon.d66e67a4.svg";